import React, { useEffect, useState } from 'react';
import { Drawer } from 'components/shared/Drawer';
import WebView from 'services/webview';
import PropTypes from 'prop-types';
import groceryIcon from 'assets/images/sample/grocery.svg';
import electronicIcon from 'assets/images/sample/electronics.svg';
import artIcon from 'assets/images/sample/art.svg';
import homeEssentialIcon from 'assets/images/sample/homeEssentials.svg';
import fashionIcon from 'assets/images/sample/fashion.svg';
import ebooksIcon from 'assets/images/sample/ebooks.svg';
import sportsIcon from 'assets/images/sample/sports.svg';
import toyIcon from 'assets/images/sample/toys.svg';
import generalIcon from 'assets/images/sample/general.svg';
import otherIcon from 'assets/images/sample/other.svg';
import { FooterButton } from 'components/common/FooterButton';
import { Button } from 'phoenix-components';
import { Loading } from 'components/shared/Loading';
import { useDesktop } from 'contexts';
import { SideDrawer } from 'components/shared/SideDrawer';
import styles from './Sample.module.css';

export function Sample({ onBack, onClose, showCreateShop }) {
  const [open, setOpen] = useState(true);
  const isDesktop = useDesktop();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setOpen(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  const sampleCard = (image, color, title) => (
    <div className={styles.card} style={{ background: color }}>
      <div className={styles.title}>
        {title}
      </div>
      <img src={image} alt="" className={styles.img} />
    </div>
  );
  return (
    <>
      {isDesktop ? (
        <SideDrawer
          backButton={true}
          onClose={onBack}
          title="Sample Shops"
          button={showCreateShop}
          btnLabel="Create Shop"
          onClick={onClose}
        >
          {open && (<Loading />)}
          <div className={styles.container}>
            {sampleCard(groceryIcon, '#FFEEEE', 'Grocery/Food/Beverages/ Restaurants & Hotels')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://grocerease.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />
            {sampleCard(electronicIcon, '#F7ECDE', 'Electronics/Computer Accessories')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://digitaldensample.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />
            {sampleCard(artIcon, '#DBDFFD', 'Art/Painting/Photography')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://canvascraft.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(homeEssentialIcon, '#DBF3FD', 'Home essentials/ Furniture')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://furnishflow.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(fashionIcon, '#DBFDEF', 'Apparel/ Fashion/ Shoes/ Accessories')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://stylesavvybyanna.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(ebooksIcon, '#F5E3DD', 'Digital products/ Ebooks/ Online Courses')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://digitalproductsebooksonlinecourses.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(sportsIcon, '#FFEFD1', 'Sports/ Fitness/Outdoor')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://sportsfitnessoutdoor.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(toyIcon, '#E3EBFF', 'Toys/Crafts/Hobbies/Gifts/Pet Care')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://playfulwondersbyanna.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(generalIcon, '#D1BB99', 'General E-commerce')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://generalecommerce.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(otherIcon, '#F0F0F0', 'Other')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://charmstorebyanna.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />
          </div>
        </SideDrawer>
      ) : (
        <Drawer
          title="Sample Shops"
          onClose={onBack}
        >
          {open && (<Loading />)}
          <div className={styles.container}>
            {sampleCard(groceryIcon, '#FFEEEE', 'Grocery/Food/Beverages/ Restaurants & Hotels')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://grocerease.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />
            {sampleCard(electronicIcon, '#F7ECDE', 'Electronics/Computer Accessories')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://digitaldensample.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />
            {sampleCard(artIcon, '#DBDFFD', 'Art/Painting/Photography')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://canvascraft.mywindo.site/';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(homeEssentialIcon, '#DBF3FD', 'Home essentials/ Furniture')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://furnishflow.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(fashionIcon, '#DBFDEF', 'Apparel/ Fashion/ Shoes/ Accessories')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://stylesavvybyanna.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(ebooksIcon, '#F5E3DD', 'Digital products/ Ebooks/ Online Courses')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://digitalproductsebooksonlinecourses.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(sportsIcon, '#FFEFD1', 'Sports/ Fitness/Outdoor')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://sportsfitnessoutdoor.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(toyIcon, '#E3EBFF', 'Toys/Crafts/Hobbies/Gifts/Pet Care')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://playfulwondersbyanna.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />

            {sampleCard(generalIcon, '#D1BB99', 'General E-commerce')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://generalecommerce.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />
            {sampleCard(otherIcon, '#F0F0F0', 'Other')}
            <div className="marginMTopBottom" />
            <div className="flexCenter">
              <Button
                dataId="sample-viewshop-button"
                label="View Shop"
                size="medium"
                primary={false}
                bordered={true}
                onClick={() => {
                  const ind = 'https://charmstorebyanna.mywindo.site';
                  if (WebView.isWebView()) {
                    WebView.openUrl(ind);
                    return;
                  }
                  window.open(ind, '_blank');
                }}
              />
            </div>
            <div className="marginMTopBottom" />
          </div>
          {showCreateShop && (
            <FooterButton>
              <div className={styles.btns}>
                <Button
                  dataId="sample-createshop-button"
                  label="Create Shop"
                  size="large"
                  fullWidth
                  primary={true}
                  bordered={false}
                  onClick={onClose}
                />
              </div>
            </FooterButton>
          )}
        </Drawer>
      )}
    </>
  );
}

Sample.propTypes = {
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  showCreateShop: PropTypes.bool,
};
Sample.defaultProps = {
  showCreateShop: true,
};
